module.exports = __webpack_public_path__ + "static/11-b9e4caae3d6a7e46e61c826556ca09c8.jpg";